import { defineComponent as _defineComponent } from 'vue'
import OzBaseButton from '@@/library/v4/components/OzBaseButton.vue'
import OzIndeterminateSpinner from '@@/library/v4/components/OzIndeterminateSpinner.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'OzRowToggle',
  props: {
    label: null,
    darkMode: { type: [Boolean, String], default: 'auto' },
    disabled: { type: Boolean },
    value: { type: Boolean },
    testId: { default: '' },
    isLoading: { type: Boolean, default: false },
    minHeight: { default: 14 }
  },
  emits: ['click', 'focus', 'blur'],
  setup(__props: any) {

const props = __props as { label: string, darkMode: boolean | 'auto', disabled?: boolean, value: boolean, testId: string, isLoading: boolean, minHeight: 0 | 14 }





return { __sfc: true,props, OzBaseButton, OzIndeterminateSpinner }
}

})